<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
  class="bg-default dark:bg-card print:hidden"
  [class.dense-navigation-expanded]="!isScreenSmall && isNavigationExpanded"
  [appearance]="navigationAppearance"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation"
  [opened]="!isScreenSmall"
  [hoverable]="false"
>
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <div class="dense-navigation-brand flex h-18 w-full items-center px-2">
      <!-- Single persistent brand row: the logo stays left-aligned in both
           states and only animates its scale; the collapse button is added
           on the right while expanded. -->
      <div
        class="dense-navigation-brand-row flex w-full items-center justify-between gap-3"
      >
        <button
          type="button"
          class="dense-navigation-logo button-icon rounded-md"
          [class.is-expanded]="!isScreenSmall && isNavigationExpanded"
          cdkOverlayOrigin
          #sidebarLogoHintOrigin="cdkOverlayOrigin"
          (click)="onLogoClick()"
          (mouseenter)="onLogoMouseEnter()"
          (mouseleave)="sidebarLogoState = 'a'"
          [attr.aria-label]="
            !isScreenSmall && isNavigationExpanded ? 'AEM+' : 'Expand sidebar'
          "
          [title]="
            !isScreenSmall && isNavigationExpanded ? 'AEM+' : 'Expand sidebar'
          "
        >
          <span class="t-icon-swap" [attr.data-state]="sidebarLogoState">
            <span class="t-icon flex items-center justify-center" data-icon="a">
              <img
                class="dense-navigation-logo-img size-6 block dark:hidden"
                src="images/logo/AEM-Plus-dark-24px.svg"
                alt="AEM+"
              />
              <img
                class="dense-navigation-logo-img size-6 hidden dark:block"
                src="images/logo/AEM-Plus-white-24px.svg"
                alt="AEM+"
              />
            </span>

            <span class="t-icon flex items-center justify-center" data-icon="b">
              <mat-icon [svgIcon]="'feather:sidebar'"></mat-icon>
            </span>
          </span>
        </button>

        @if (!isScreenSmall && isNavigationExpanded) {
          <button
            type="button"
            class="button-ghost button-icon"
            (click)="toggleNavigation('mainNavigation')"
            matTooltip="Collapse sidebar"
            aria-label="Collapse sidebar"
            title="Collapse sidebar"
          >
            <mat-icon [svgIcon]="'feather:sidebar'"></mat-icon>
          </button>
        }
      </div>

      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="sidebarLogoHintOrigin"
        [cdkConnectedOverlayOpen]="
          showSidebarLogoHint &&
          isSidebarLogoHintOriginVisible &&
          !isScreenSmall &&
          !isNavigationExpanded
        "
        [cdkConnectedOverlayPanelClass]="sidebarLogoHintOverlayClass"
        [cdkConnectedOverlayPush]="true"
        [cdkConnectedOverlayViewportMargin]="12"
        [cdkConnectedOverlayPositions]="sidebarLogoHintPositions"
      >
        <div
          class="dense-logo-hint-bubble"
          role="note"
          aria-label="Click the logo button to expand the sidebar"
        >
          <div class="dense-logo-hint-arrow" aria-hidden="true"></div>

          <div class="dense-logo-hint-content">
            <mat-icon
              class="dense-logo-hint-icon"
              [svgIcon]="'heroicons_outline:cursor-arrow-rays'"
            ></mat-icon>
            <span>Click me</span>
          </div>

          <button
            type="button"
            class="dense-logo-hint-close"
            (click)="dismissSidebarLogoHint()"
            aria-label="Dismiss sidebar hint"
          >
            <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
          </button>
        </div>
      </ng-template>
    </div>
  </ng-container>
  <ng-container fuseVerticalNavigationFooter>
    <div class="dense-sidebar-footer p-2">
      <user variant="sidebar-footer"></user>
    </div>
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div
  class="flex h-full min-h-0 w-full min-w-0 flex-auto flex-col overflow-hidden"
>
  <!-- Header -->
  <div
    class="bg-card relative z-49 flex h-12 w-full flex-0 items-center border-b px-4 dark:bg-transparent dark:shadow-none print:hidden"
  >
    @if (isScreenSmall) {
      <button
        class="-ml-2 button-icon rounded-md"
        (click)="toggleNavigation('mainNavigation')"
      >
        <mat-icon [svgIcon]="'feather:sidebar'"></mat-icon>
      </button>
    }
    <app-page-header
      class="flex h-full min-w-0 flex-1 items-center"
    ></app-page-header>
  </div>

  <!-- Content -->
  <div
    class="dense-content relative flex h-0 min-h-0 flex-1 flex-col overflow-hidden"
  >
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <app-marquee [items]="marqueeItems"></app-marquee>
      <router-outlet></router-outlet>
    }
  </div>
</div>
